import React, { Suspense, useState } from "react";
import LoadingSpinner from "@/components/shared/LoadingSpinner";
import BuyCarAuctionsHero from "@/components/buycarauctions/BuyCarAuctionsHero";
import AuctionTypesSection from "@/components/buycarauctions/AuctionTypesSection";
import AccountBenefitsSection from "@/components/buycarauctions/AccountBenefitsSection";
import TransparencySection from "@/components/buycarauctions/TransparencySection";
import DeliverySection from "@/components/buycarauctions/DeliverySection";
import CustomerServiceSection from "@/components/buycarauctions/CustomerServiceSection";
import SecuritySection from "@/components/buycarauctions/SecuritySection";
import CTASection from "@/components/buycarauctions/CTASection";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { CarValuationWidget } from "@/components/valuation/CarValuationWidget";

const BuyCarAuctions = () => {
  const [showValuation, setShowValuation] = useState(false);

  return (
    <div className="overflow-x-hidden backdrop-blur">
      <>
        <title>
          Köp Bil På Auktion | BILENIA - Sveriges Största Bilauktioner
        </title>
        <meta
          name="description"
          content="Köp bil på auktion hos BILENIA. Olika auktionstyper från 24h till 7 dagar. Skapa konto, buda på bilar och vinn till bästa pris. Transparent testning och säker betalning."
        />
        <meta
          name="keywords"
          content="köpa bil auktion, bilauktion sverige, buda på bil, köp bil online, bilauktioner, bil till salu, BILENIA auktion, handlare bilauktion"
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            name: "BILENIA Bilauktioner",
            description:
              "Sveriges största bilauktioner med transparent testning och säker betalning",
            provider: {
              "@type": "AutoDealer",
              name: "BILENIA",
              address: {
                "@type": "PostalAddress",
                streetAddress: "Personnevägen 6",
                addressLocality: "Hägersten",
                postalCode: "129 49",
                addressCountry: "SE",
              },
            },
            areaServed: "Sverige",
            serviceType: "Bilauktion",
            offers: {
              "@type": "Offer",
              description: "Köp bil på auktion med transparent testning",
              availability: "https://schema.org/InStock",
            },
          })}
        </script>
      </>

      <Suspense fallback={<LoadingSpinner />}>
        <BuyCarAuctionsHero />
      </Suspense>

      <AuctionTypesSection />
      <AccountBenefitsSection />
      <TransparencySection />
      <DeliverySection />
      <CustomerServiceSection />
      <SecuritySection onValuationClick={() => setShowValuation(true)} />
      <CTASection />

      {/* Car Valuation Dialog */}
      <Dialog open={showValuation} onOpenChange={setShowValuation}>
        <DialogContent className="max-w-3xl max-h-[85%] overflow-y-auto">
          <CarValuationWidget
            onClose={() => setShowValuation(false)}
            showCloseButton={false}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default BuyCarAuctions;
